import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import InterviewerScheduleComponent from "../../components/interviewer/schedule/InterviewerScheduleComponent";
import MasterDataService from '../../services/master-data-service';
import toasterUtils from "../../utils/toaster-utils";
import IdNameModel from "../../models/common/IdNameModel";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";

const InterviewerSchedule = () => {
    const history = useHistory();
    const [timeSlots, setTimeSlots] = useState<IdNameModel[]>([]);
    const [refreshInterviewerSchedule, setRefreshInterviewerSchedule] = useState<number>(2);

    useEffect(() => {
        getTimeSlots();
    }, [])

    const getTimeSlots = () => {
        modalUtils.showLoader();
        MasterDataService.loadTimeSlots().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setTimeSlots(res.items);
            setRefreshInterviewerSchedule(refreshInterviewerSchedule * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Primary skills");
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Schedule
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header">SCHEDULES</h4>
            </div>
            {timeSlots.length > 0 &&
                <InterviewerScheduleComponent
                    key={refreshInterviewerSchedule}
                    tileSlotsList={timeSlots} />
            }
        </Layout>
    );
};
export default InterviewerSchedule;